module.exports = __webpack_public_path__ + "static/media/btn_more_nor.0e626ac3.svg";